/* eslint-disable no-unused-vars */
import {
  QuestionFormFieldWithOptions,
  QuestionFormFieldWithOptionsType,
} from './questionFormFieldWithOptions'

/**
 * Creates an instance of SelectBoxField.
 * @typedef {Object} SelectBoxFieldType
 *
 * @typedef {QuestionFormFieldWithOptionsType & SelectBoxFieldType} SelectBoxFieldExtendType
 */

/**
 * Represents a select box form field.
 * @class
 */
export class SelectBoxField extends QuestionFormFieldWithOptions {}
